module.exports = __webpack_public_path__ + "img/check.4ac117e2.svg";